import React, { FC, useMemo } from "react"
import { ReactComponent as IconSpinner } from "icons/lib/spinner.svg"
import {
    AIModelAssignment,
    AIModelAssignmentEnum
} from "../../../../../../../../Models/API/AIModel"
import { AIModelActivenessCheckbox } from "./AIModelActivenessCheckbox"

interface AIModelUsageListItemProps {
    isModelOnline: boolean
    assignment: AIModelAssignment
    isProcessing: boolean
    onChangeActiveness?: (
        assigned: AIModelAssignmentEnum,
        active: boolean,
        useLatestAi: boolean
    ) => void
}

export const AIModelUsageListItem: FC<AIModelUsageListItemProps> = ({
    isModelOnline,
    assignment,
    isProcessing,
    onChangeActiveness
}) => {
    const handleChangeActiveness = useMemo(
        () =>
            onChangeActiveness === undefined || !isModelOnline
                ? undefined
                : () =>
                      onChangeActiveness(
                          assignment.assigned,
                          !assignment.active,
                          !!assignment.use_latest_ai
                      ),
        [
            assignment.active,
            assignment.assigned,
            assignment.use_latest_ai,
            isModelOnline,
            onChangeActiveness
        ]
    )

    const handleChangeVersion = useMemo(
        () =>
            onChangeActiveness === undefined || !isModelOnline
                ? undefined
                : () =>
                      onChangeActiveness(
                          assignment.assigned,
                          !!assignment.active,
                          !assignment.use_latest_ai
                      ),
        [
            assignment.active,
            assignment.assigned,
            assignment.use_latest_ai,
            isModelOnline,
            onChangeActiveness
        ]
    )

    return (
        <li
            key={assignment.assigned}
            className="flex items-center"
            data-testid="model-assignment"
        >
            <div className="flex items-center">
                <AIModelActivenessCheckbox
                    isProcessing={isProcessing}
                    isActive={isModelOnline && assignment.active}
                    onClick={handleChangeActiveness}
                />
                {assignment.assigned === "ACTIVE_LEARNING"
                    ? `Active learning (threshold: ${assignment.threshold})`
                    : assignment.assigned === "TASK"
                    ? "Task"
                    : "Pre-processing"}
                {handleChangeVersion !== undefined ? (
                    <>
                        <AIModelActivenessCheckbox
                            isProcessing={isProcessing || !assignment.active}
                            isActive={
                                isModelOnline && !!assignment.use_latest_ai
                            }
                            onClick={handleChangeVersion}
                            className="ml-2"
                        />
                        Subscribe to latest version
                    </>
                ) : null}
                {isProcessing ? <IconSpinner className="ml-1 w-h h-4" /> : null}
            </div>
        </li>
    )
}
